import { Typography } from "@mui/material";
import { KVCardRow } from "./CardContent";

export default function ActionCardContent({ node }) {
  const requiredParams = node.data.requiredParameters;
  const requiredParamsDict = Object.assign(
    {},
    ...requiredParams.map((param) => ({ [param.field]: param.data_type }))
  );

  let params;

  if ("parameters" in node.data) {
      params = Object.keys(node.data.parameters).map((param) => {
      const isRequired = param in requiredParamsDict;
  
      return (
        <Typography key={param} variant="body2" color={"#b5b5b5"}>
          <b>{param}</b> {isRequired ? <span>(required)</span> : <></>}
        </Typography>
      );
    });
  }


  return (
    <div>
      <KVCardRow label="Connector" value={node.data.connector}></KVCardRow>
      <KVCardRow
        label="Description"
        value={node.data.advanced.description}
      ></KVCardRow>
      <KVCardRow label="Note" value={node.data.advanced.note}></KVCardRow>
      {params ? <KVCardRow label="Inputs" value={params}></KVCardRow>: <></>}
    </div>
  );
}
